import React, { useRef } from 'react';
import { useClickAway } from 'ahooks';
import cn from 'classnames';
import { CloseIcon } from '@y2/mango/components/icons';

import styles from './feedback-popup-layout.module.scss';
import { PopupWrapper } from '../popup-wrapper/popup-wrapper';

type Props = {
  className?: string;
  onClose: () => void;
  illustration: React.ReactNode;
  heading: string;
  message: string;
  action?: React.ReactNode;
  bottomSlot?: React.ReactNode;
};

export const FeedbackPopupLayout = ({
  className,
  onClose,
  illustration,
  heading,
  message,
  action,
  bottomSlot,
}: Props) => {
  const popupRef = useRef(null);
  useClickAway(onClose, popupRef);

  return (
    <PopupWrapper>
      <div
        className={cn(styles.feedbackPopupLayoutBox, className)}
        ref={popupRef}
      >
        <button onClick={onClose} className={styles.closeButton}>
          <CloseIcon />
        </button>

        <div className={styles.illustrationBox}>{illustration}</div>
        <h3 className={styles.heading}>{heading}</h3>
        <p className={styles.message}>{message}</p>
        {action && <div className={styles.actionBox}>{action}</div>}
        {bottomSlot && <div className={styles.bottomSlot}>{bottomSlot}</div>}
      </div>
    </PopupWrapper>
  );
};
